import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpsertAllowedRolesMutationVariables = Types.Exact<{
  allowedRolesObj: Array<Types.Usertoroles_Insert_Input> | Types.Usertoroles_Insert_Input;
}>;


export type UpsertAllowedRolesMutation = { __typename?: 'mutation_root', insert_usertoroles?: { __typename?: 'usertoroles_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'usertoroles', user_id: number, role_id: number }> } | null };


export const UpsertAllowedRolesDocument = gql`
    mutation upsertAllowedRoles($allowedRolesObj: [usertoroles_insert_input!]!) {
  insert_usertoroles(
    objects: $allowedRolesObj
    on_conflict: {constraint: usertoroles_user_id_role_id_key, update_columns: []}
  ) {
    affected_rows
    returning {
      user_id
      role_id
    }
  }
}
    `;
export type UpsertAllowedRolesMutationFn = Apollo.MutationFunction<UpsertAllowedRolesMutation, UpsertAllowedRolesMutationVariables>;

/**
 * __useUpsertAllowedRolesMutation__
 *
 * To run a mutation, you first call `useUpsertAllowedRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAllowedRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAllowedRolesMutation, { data, loading, error }] = useUpsertAllowedRolesMutation({
 *   variables: {
 *      allowedRolesObj: // value for 'allowedRolesObj'
 *   },
 * });
 */
export function useUpsertAllowedRolesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAllowedRolesMutation, UpsertAllowedRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAllowedRolesMutation, UpsertAllowedRolesMutationVariables>(UpsertAllowedRolesDocument, options);
      }
export type UpsertAllowedRolesMutationHookResult = ReturnType<typeof useUpsertAllowedRolesMutation>;
export type UpsertAllowedRolesMutationResult = Apollo.MutationResult<UpsertAllowedRolesMutation>;
export type UpsertAllowedRolesMutationOptions = Apollo.BaseMutationOptions<UpsertAllowedRolesMutation, UpsertAllowedRolesMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/userManagement/queries/upsertAllowedRoles.mutation.gql}
 */
export async function upsertAllowedRoles(
  variables: UpsertAllowedRolesMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpsertAllowedRolesMutation['insert_usertoroles']>
export async function upsertAllowedRoles(
  variables: UpsertAllowedRolesMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpsertAllowedRolesMutation>
export async function upsertAllowedRoles(
  variables: UpsertAllowedRolesMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpsertAllowedRolesMutation['insert_usertoroles'] | UpsertAllowedRolesMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpsertAllowedRolesMutation>(
    UpsertAllowedRolesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_usertoroles
}